import * as React from 'react';
import { SurveyContainer } from './Style';

type SurveyProps = {
  urlWithParams: string;
};

const SurveyScriptInsert: React.FunctionComponent<SurveyProps> = ({
  urlWithParams,
}): JSX.Element => {
  return (
    <SurveyContainer>
      <iframe id="survey-iframe" title="survey" src={urlWithParams} />
    </SurveyContainer>
  );
};

export default SurveyScriptInsert;
